export class Favored {
  id: number = null;
  name: string = null;
  document: string = null;
  bank: string = null;
  branch: string = null;
  account: string = null;
  isNewFavored: boolean = false;
}
